import { ArrivalService } from 'core/analytics/interfaces';
import { BASE_ROUTES } from 'core/common/constants';
import { useIsomorphicLayoutEffect } from 'core/common/hooks/useIsomorphicLayoutEffect';
import { useRouter } from 'core/common/hooks/useRouter';
import { Languages } from 'core/localization/entities';

export const useTrackArrival = (arrivalService: ArrivalService) => {
  const { locale = Languages.EN, pathname } = useRouter();

  const isDraftPreview = pathname.startsWith(BASE_ROUTES.DRAFT);

  useIsomorphicLayoutEffect(() => {
    if (isDraftPreview) return;

    arrivalService.trackArrival(locale);
  }, [arrivalService, isDraftPreview, locale]);
};
